import { IKeyName } from "../interfaces/IKeyName";

export class KeyName implements IKeyName {
	public key: string = "";
	public name: string = "";
	public funnelName?: string = "";
	public funnelKey?: string = "";
	public description?: string = "";
	public funnelDescription?: string = "";

	constructor(object: IKeyName = {} as IKeyName) {
		this.key = object.key;
		this.name = object.name;
		this.funnelName = object.funnelName || "";
		this.funnelKey = object.funnelKey || "";
		this.description = object.description || "";
		this.funnelDescription = object.funnelDescription || "";
	}
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/KeyName.ts